import React, { useEffect, useState } from "react";
import axios from "axios";
import HeadRegresar from "../../sharecomponents/HeadRegresar";
import { API_URL } from "../../../utils/Common";

const initForm = Object.freeze({
   id: 0,
   codigo: "",
   largo: 0,
   no_camas: 0,
   agua: "",
   micro: "Ninguno",
   electrificada: "Ninguno",
   hoops: "Ninguno",
   sombra: "Ninguno",
   totalm2: 0,
});

// -- para las actualizaciones
const updateForm = Object({
   id: "0",
   codigo: "",
   largo: "0",
   no_camas: "0",
   agua: "",
   micro: "",
   electrificada: "",
   hoops: "",
   sombra: "",
});

const InfoRancho = (props) => {
   const ranchoId = props.match.params.id;

   const [rancho, setRancho] = useState({});
   const [formulario, setFormulario] = useState(initForm);

   useEffect(() => {
      getInfoRancho();
   }, [ranchoId]);

   const getInfoRancho = () => {
      console.log("getInfoRancho");
      axios
         .get(API_URL + "/getRancho", { params: { id: ranchoId } })
         .then((r) => {
            console.log(r.data);
            setRancho(r.data.rancho);
         })
         .catch((e) => console.log(e));
   };

   const handleChange = (e) => {
      setFormulario({
         ...formulario,
         [e.target.name]: e.target.value,
      });
   };

   const editarFrmValvula = (v) => {
      updateForm.id = v.id;
      updateForm.codigo = v.codigo;
      updateForm.largo = v.largo;
      updateForm.no_camas = v.no_camas;
      updateForm.agua = v.agua;
      updateForm.micro = v.micro;
      updateForm.electrificada = v.electrificada;
      updateForm.hoops = v.hoops;
      updateForm.sombra = v.sombra;
      updateForm.totalm2 = v.totalm2;

      console.log(v);
      setFormulario({ ...v });
   };

   const guardar = (e) => {
      e.preventDefault();
      console.log(formulario);

      axios
         .post(API_URL + "/guardarValvula", { ...formulario, ranchoId })
         .then((r) => {
            console.log(r.data);
            getInfoRancho();
            setFormulario(initForm);
         })
         .catch((e) => console.log(e));
      //NOTE: Debe estar fuera del AXIOS
      e.target.reset();
   };

   const removerValvula = (v) => {
      console.log(v);
      axios
         .delete(API_URL + "/eliminarValvula", { params: { id: v.id } })
         .then((r) => {
            console.log(r.data);
            getInfoRancho();
         })
         .catch((e) => console.log(e));
   };

   console.log(ranchoId);
   return (
      <div className="w-full p-3">
         <div className="bg-white border rounded shadow">
            <div className="border-b rounded-t p-3 bg-orange-900">
               <HeadRegresar titulo={"Rancho: " + rancho.nombre} history={props.history} />
            </div>
            <div className="p-5 rounded-b">
               <h4 className="text-orange-900">I. Agregar Válvula</h4>
               <hr className="mb-3" />
               <form onSubmit={guardar} className="mb-10">
                  <div className="flex flex-wrap my-2">
                     <div className="w-1/4 px-2">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                           Código Válvula:
                        </label>
                        <input
                           className="text-sm appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                           name="codigo"
                           type="text"
                           value={formulario.codigo}
                           onChange={handleChange}
                        />
                     </div>
                     <div className="w-1/4 px-2">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                           Largo:
                        </label>
                        <input
                           className="text-sm text-right appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                           name="largo"
                           type="number"
                           step="any"
                           value={formulario.largo}
                           onChange={handleChange}
                        />
                     </div>
                     <div className="w-1/4 px-2">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                           No. Camas:
                        </label>
                        <input
                           className="text-sm text-right appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                           name="no_camas"
                           type="number"
                           value={formulario.no_camas}
                           onChange={handleChange}
                        />
                     </div>
                     <div className="w-1/4 px-2">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                           Tipo de Agua:
                        </label>
                        <input
                           className="text-sm appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                           name="agua"
                           type="text"
                           value={formulario.agua}
                           onChange={handleChange}
                        />
                     </div>
                  </div>
                  <div className="flex flex-wrap my-2">
                     <div className="w-1/4 px-2">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                           Micro:
                        </label>
                        <div className="relative">
                           <select
                              className="block text-sm appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              name="micro"
                              value={formulario.micro}
                              onChange={handleChange}
                           >
                              <option value="Ninguno">Ninguno</option>
                              <option value="Si">Si</option>
                              <option value="No">No</option>
                           </select>
                           <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                              <svg
                                 className="fill-current h-4 w-4"
                                 xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 20 20"
                              >
                                 <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                              </svg>
                           </div>
                        </div>
                     </div>
                     <div className="w-1/4 px-2">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                           Electrificada:
                        </label>
                        <div className="relative">
                           <select
                              className="block text-sm appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              name="electrificada"
                              value={formulario.electrificada}
                              onChange={handleChange}
                           >
                              <option value="Ninguno">Ninguno</option>
                              <option value="Si">Si</option>
                              <option value="No">No</option>
                           </select>
                           <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                              <svg
                                 className="fill-current h-4 w-4"
                                 xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 20 20"
                              >
                                 <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                              </svg>
                           </div>
                        </div>
                     </div>
                     <div className="w-1/4 px-2">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                           Hoops:
                        </label>
                        <div className="relative">
                           <select
                              className="block text-sm appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              name="hoops"
                              value={formulario.hoops}
                              onChange={handleChange}
                           >
                              <option value="Ninguno">Ninguno</option>
                              <option value="Si">Si</option>
                              <option value="No">No</option>
                           </select>
                           <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                              <svg
                                 className="fill-current h-4 w-4"
                                 xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 20 20"
                              >
                                 <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                              </svg>
                           </div>
                        </div>
                     </div>
                     <div className="w-1/4 px-2">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                           Sombra:
                        </label>
                        <div className="relative">
                           <select
                              className="block text-sm appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              name="sombra"
                              value={formulario.sombra}
                              onChange={handleChange}
                           >
                              <option value="Ninguno">Ninguno</option>
                              <option value="Si">Si</option>
                              <option value="No">No</option>
                           </select>
                           <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                              <svg
                                 className="fill-current h-4 w-4"
                                 xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 20 20"
                              >
                                 <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                              </svg>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="flex flex-wrap my-2">
                     <div className="w-1/4 px-2">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                           Suma de mt2:
                        </label>
                        <input
                           className="text-sm text-right appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                           name="totalm2"
                           type="text"
                           value={formulario.totalm2}
                           onChange={handleChange}
                        />
                     </div>
                  </div>
                  <button
                     type="submit"
                     className="text-xs ml-2 bg-orange-700 hover:bg-orange-700 text-white py-2 px-4 rounded shadow mt-2 focus:outline-none"
                  >
                     Agregar/Guardar
                  </button>
               </form>
               <h4 className="text-orange-900">II. Válvulas del Rancho</h4>
               <hr className="mb-3" />
               <table>
                  <thead>
                     <tr className="text-xs text-white content-center bg-orange-800">
                        <th className="bg-white border-white border-l-0 border-t-0"></th>
                        <th className="px-4 py-2">Código</th>
                        <th className="px-4 py-2">No. Camas</th>
                        <th className="px-4 py-2">Largo</th>
                        <th className="px-4 py-2">Suma de mt2</th>
                        <th className="px-4 py-2">Tipo de Agua</th>
                        <th className="px-4 py-2">Electrificada</th>
                        <th className="px-4 py-2">Hoops</th>
                        <th className="px-4 py-2">Micro</th>
                        <th className="px-4 py-2">Sombra</th>
                     </tr>
                  </thead>
                  <tbody>
                     {rancho.valvulas &&
                        rancho.valvulas.map((v, i) => {
                           return (
                              <tr key={i}>
                                 <td className="border px-4 py-2 text-center" style={{ width: "110px" }}>
                                    <button
                                       className="px-1 py-1 focus:outline-none mr-2"
                                       onClick={() => removerValvula(v)}
                                    >
                                       <i className="far fa-trash-alt" />
                                    </button>
                                    <button
                                       className="px-1 py-1 focus:outline-none"
                                       onClick={() => editarFrmValvula(v)}
                                    >
                                       <i className="fas fa-edit" />
                                    </button>
                                 </td>
                                 <td className="w-40 border px-4 py-2 text-center">{v.codigo}</td>
                                 <td className="w-40 border px-4 py-2 text-center">{v.no_camas}</td>
                                 <td className="w-40 border px-4 py-2 text-center">{v.largo}</td>
                                 <td className="w-40 border px-4 py-2 text-center">{v.totalm2}</td>
                                 <td className="w-40 border px-4 py-2 text-center">{v.tipo_agua}</td>
                                 <td className="w-40 border px-4 py-2 text-center">{v.electrificada}</td>
                                 <td className="w-40 border px-4 py-2 text-center">{v.hoops}</td>
                                 <td className="w-40 border px-4 py-2 text-center">{v.micro}</td>
                                 <td className="w-40 border px-4 py-2 text-center">{v.sombra}</td>
                              </tr>
                           );
                        })}
                  </tbody>
               </table>
            </div>
         </div>
      </div>
   );
};

export default InfoRancho;
